// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_1oI","cls2":"download_preflight-cls2_VpV download_preflight-cls1_1oI"};